import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Tooltip,
  Select,
  Form,
  Empty,
  notification,
  Divider,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  CheckOutlined,
  UploadOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import {
  getGuestLecturesmanu,
  resetState,
} from "../features/guest-lectures/guestlectureSlice";
import ImagePopupModal from "../components/ImagePopupModal";
import { FaEye } from "react-icons/fa";
import { CSVLink } from "react-csv";
import { getStates } from "../features/statecity/statecitySlice";
import { getUsers } from "../features/cutomers/customerSlice";
import { getBrands } from "../features/brand/brandSlice";
import axios from "axios";
import { base_url } from "../utils/baseUrl";
import { formatDate } from "../utils/dateHelper";

const Guestlecture = () => {
  const [selectionType] = useState("checkbox");
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [vcData, setVcData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [vtData, setVtData] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedVC, setSelectedVC] = useState("");
  const [selectedVT, setSelectedVT] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [filteredGuestLecture, setFilteredGuestLecture] = useState([]);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);

  const statelistState = useSelector(
    (state) => state.statecity.statelist || []
  );
  const vclistState = useSelector((state) => state.customer.customers || []);
  const classlistState = useSelector((state) => state.brand.brands || []);
  const { guestlecture, isLoading } = useSelector(
    (state) => state.guestlectures
  );

  useEffect(() => {
    dispatch(resetState());
    dispatch(getGuestLecturesmanu());
    dispatch(getStates());
    dispatch(getUsers());
    dispatch(getBrands());
  }, [dispatch]);

  useEffect(() => {
    if (guestlecture.length > 0 && !initialDataLoaded) {
      handleSubmit();
      setInitialDataLoaded(true);
    }
  }, [guestlecture, initialDataLoaded]);

  const handleImageClick = (images) => {
    setSelectedImages(images);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedImages([]);
  };

  const handleStateChange = (value) => {
    const vcFilterData = vclistState.filter(
      (customer) => customer.state === value
    );
    setVcData(vcFilterData);
    setSelectedState(value);
    setSelectedVC(""); // Reset VC when state changes
    setSelectedVT(""); // Reset VT when state changes
    setVtData([]); // Clear VT options
  };

  const handleVcChange = (value) => {
    const vtFilterData = vclistState.filter(
      (customer) => customer.vcuser_id === value
    );
    setVtData(vtFilterData);
    setSelectedVC(value);
    setSelectedVT(""); // Reset VT when VC changes
  };

  const handleVTChange = (value) => {
    setSelectedVT(value);
  };

  const handleClassChange = (value) => {
    setSelectedClass(value);
  };

  const handleSubmit = () => {
    const filteredData = guestlecture.filter((guestl) => {
      const matchesState = selectedState
        ? guestl.userDetails?.state === selectedState
        : true;
      const matchesVT = selectedVT
        ? guestl.userDetails?._id === selectedVT
        : true;
      const matchesClass = selectedClass
        ? guestl.class === selectedClass
        : true;

      return matchesState && matchesVT && matchesClass;
    });

    setFilteredGuestLecture(filteredData);
  };

  const handleClear = () => {
    form.resetFields();
    setSelectedState("");
    setSelectedVC("");
    setSelectedVT("");
    setSelectedClass("");
    setFilteredGuestLecture(guestlecture);
    setVcData([]);
    setVtData([]);
  };

  const handleApprove = async () => {
    if (selectedRowKeys.length === 0) {
      notification.error({
        message: "No Selection",
        description: "Please select at least one guest lecture to approve.",
      });
      return;
    }

    setLoading(true);

    try {
      const userinfo = localStorage.getItem("user");
      const userData = JSON.parse(userinfo);
      const token = userData.token;

      if (!token) {
        throw new Error("Token not found in local storage");
      }

      const docIds = selectedRowKeys;
      await axios.put(
        `${base_url}guestlecture/approveall`,
        {
          doc_id: docIds,
          approve: true,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      notification.success({
        message: "Approval Successful",
        description: "Selected guest lectures have been approved successfully.",
      });

      setSelectedRowKeys([]);
      dispatch(getGuestLecturesmanu());
    } catch (error) {
      console.error("Error approving guest lectures:", error);
      notification.error({
        message: "Approval Failed",
        description: "There was an error approving the guest lectures.",
      });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      dataIndex: "key",
      title: "Sr No",
      width: 60,
    },
    {
      dataIndex: "date",
      title: "Schedule Date",
      width: 120,
      render: (text) => formatDate(text) || "N/A",
    },
    {
      dataIndex: "class",
      title: "Class",
      width: 80,
    },
    {
      dataIndex: "guest_name",
      title: "Guest Name",
      width: 150,
    },
    {
      dataIndex: "topic_name",
      title: "Topic Name",
      width: 200,
    },
    {
      dataIndex: "contact_no",
      title: "Contact No",
      width: 120,
    },
    {
      dataIndex: "timing",
      title: "Timing",
      width: 100,
    },
    {
      dataIndex: "scheduled_by",
      title: "Scheduled By",
      width: 150,
    },
    {
      dataIndex: "school_name",
      title: "School Name",
      width: 200,
    },
    {
      dataIndex: "approve",
      title: "Approve Status",
      width: 100,
      render: (text) => (text ? "Yes" : "No"),
    },
    {
      dataIndex: "approve_by",
      title: "Approved By",
      width: 150,
    },
    {
      dataIndex: "created_at",
      title: "Created At",
      width: 150,
      render: (text) => formatDate(text) || "N/A",
    },
    {
      dataIndex: "uploaded_doc",
      title: "Uploaded Doc",
      width: 100,
      render: (text, record) => (
        <Button
          shape="circle"
          icon={<UploadOutlined />}
          onClick={() => handleImageClick(record.uploaded_doc)}
        />
      ),
    },
  ];

  const data1 = Array.isArray(filteredGuestLecture)
    ? filteredGuestLecture.map((guestlect, index) => {
        const extractUrls = (images) =>
          images?.map((image) => ({ url: image.url })) || [];

        return {
          key: index + 1,
          doc_id: guestlect.guestLectureId, // Use guestLectureId from API
          date: guestlect.date,
          class: guestlect.class,
          guest_name: guestlect.guest_name || "N/A",
          topic_name: guestlect.topic_name || "N/A",
          contact_no: guestlect.contact_no || "N/A",
          timing: guestlect.timing || "N/A",
          scheduled_by: guestlect.userDetails?.name || "N/A",
          school_name: guestlect.userDetails?.school_name || "N/A",
          approve: guestlect.approve || false,
          approve_by: guestlect.approvedByDetails?.name || "N/A",
          created_at: guestlect.createdAt || "N/A",
          uploaded_doc: [
            ...extractUrls(guestlect.image_start),
            ...extractUrls(guestlect.image_mid),
            ...extractUrls(guestlect.image_last),
            ...extractUrls(guestlect.image_signedform),
          ],
        };
      })
    : [];

  const csvHeaders = [
    { label: "Date", key: "date" },
    { label: "Class", key: "class" },
    { label: "Guest Name", key: "guest_name" },
    { label: "Topic Name", key: "topic_name" },
    { label: "Contact No", key: "contact_no" },
    { label: "Timing", key: "timing" },
    { label: "Scheduled By", key: "scheduled_by" },
    { label: "School Name", key: "school_name" },
    { label: "Approve Status", key: "approve" },
    { label: "Approved By", key: "approve_by" },
    { label: "Created At", key: "created_at" },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      const docIds = selectedRows.map((row) => row.doc_id);
      setSelectedRowKeys(docIds);
    },
    getCheckboxProps: (record) => ({
      disabled: record.approve === true, // Disable checkbox if already approved
    }),
  };

  return (
    <div>
      <h3 className="mb-4 title">Guest Lectures</h3>
      <div
        style={{
          marginBottom: 16,
          backgroundColor: "#ffffff",
          border: "1px solid #eef2f6",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
        }}
      >
        <Form form={form} layout="inline" onFinish={handleSubmit}>
          <Form.Item name="state_name">
            <Select
              style={{ width: 160, marginRight: 16 }}
              placeholder="Select State"
              onChange={handleStateChange}
              value={selectedState}
            >
              <Select.Option value="">Select State</Select.Option>
              {statelistState.map((state) => (
                <Select.Option key={state.state} value={state.state}>
                  {state.state_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="vc_name">
            <Select
              style={{ width: 160, marginRight: 16 }}
              placeholder="Select VC"
              onChange={handleVcChange}
              value={selectedVC}
              disabled={!selectedState}
            >
              <Select.Option value="">Select VC</Select.Option>
              {vcData
                .filter((item) => item.role === "vc")
                .map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item name="vt_name">
            <Select
              style={{ width: 160, marginRight: 16 }}
              placeholder="Select VT"
              onChange={handleVTChange}
              value={selectedVT}
              disabled={!selectedVC}
            >
              <Select.Option value="">Select VT</Select.Option>
              {vtData
                .filter((item) => item.role === "vt")
                .map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item name="class_name">
            <Select
              style={{ width: 160 }}
              placeholder="Select Class"
              onChange={handleClassChange}
              value={selectedClass}
            >
              <Select.Option value="">Select Class</Select.Option>
              {classlistState.map((cls) => (
                <Select.Option key={cls.title} value={cls.title}>
                  {cls.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Button
              style={{ marginRight: 20 }}
              type="primary"
              htmlType="submit"
            >
              <FaEye /> View
            </Button>
          </Form.Item>
          <Form.Item>
            <Button type="default" onClick={handleClear}>
              Clear
            </Button>
          </Form.Item>
        </Form>
      </div>

      <Tooltip title="Checked and Approved Guest Lectures">
        <Button
          type="primary"
          shape="round"
          icon={<CheckOutlined />}
          style={{ backgroundColor: "rgb(45 143 36)", marginRight: 16 }}
          onClick={handleApprove}
          loading={loading}
          disabled={loading || selectedRowKeys.length === 0}
        >
          Approve
        </Button>
      </Tooltip>
      <CSVLink
        data={data1}
        headers={csvHeaders}
        filename={`guestlecture_${new Date().toISOString()}.csv`}
      >
        <Button type="primary">
          <ExportOutlined /> Export to CSV
        </Button>
      </CSVLink>

      {isLoading ? (
        <div>Loading...</div>
      ) : filteredGuestLecture.length === 0 ? (
        <Empty description="No guest lectures found" />
      ) : (
        <Table
          rowSelection={{
            type: selectionType,
            ...rowSelection,
          }}
          columns={columns}
          dataSource={data1}
          style={{ marginTop: 16 }}
          scroll={{ x: 1500 }} // Enable horizontal scrolling for wide tables
        />
      )}

      <ImagePopupModal
        visible={modalVisible}
        images={selectedImages}
        onClose={closeModal}
      />

      <Divider />
    </div>
  );
};

export default Guestlecture;
